export function AppDevelopment() {
  return (
    <div className="page">
      <section className="content-section">
        <h1>App Development & Product Engineering</h1>
        <p>Build high-quality web and mobile products that deliver measurable value.</p>

        <div className="services-list">
          <div className="service-item">
            <h3>📱 Mobile Applications</h3>
            <p>Cross-platform and native mobile apps optimized for user engagement and retention.</p>
          </div>

          <div className="service-item">
            <h3>🌐 Web Platforms</h3>
            <p>Modern, responsive web applications designed for performance and growth.</p>
          </div>

          <div className="service-item">
            <h3>⚙️ Backend Systems</h3>
            <p>Reliable APIs, microservices, and data pipelines to power your product ecosystem.</p>
          </div>

          <div className="service-item">
            <h3>🔌 Integration & Automation</h3>
            <p>Connect your product to payment gateways, CRM systems, analytics tools, and more.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
